import * as PlanType from '../pricings/PlanType';
import createObjectValuesPropType from './createObjectValuesPropType';
export default createObjectValuesPropType(PlanType);